import { render, staticRenderFns } from "./ModalBuyCards.vue?vue&type=template&id=b82d7830&scoped=true&"
import script from "./ModalBuyCards.vue?vue&type=script&lang=js&"
export * from "./ModalBuyCards.vue?vue&type=script&lang=js&"
import style0 from "./ModalBuyCards.vue?vue&type=style&index=0&id=b82d7830&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82d7830",
  null
  
)

export default component.exports